<app-loading *ngIf="isLoading"></app-loading>

<div class="filter-container" style="width: 99vw;">
  <div class="filter-input-fields">
    <div *ngIf="showSystemFilter" class="mat-form-group">
      <mat-form-field class="mat-form-input-field input-field-wide">
        <mat-label class="mat-form-group-label">System</mat-label>
        <mat-select [formControl]="SystemSelected" multiple [title]="getTitleString(SystemSelected.value)">
          <mat-select-trigger class="mat-form-trigger-label">
            {{getSelectedString(SystemSelected, 'System')}}
          </mat-select-trigger>
          <mat-option #allSystemSelected [value]="allOptionText"
            (click)="allSelectedHandler(SystemSelected,SystemData,allSystemSelected,'System')">{{allOptionText}}
          </mat-option>
          <mat-divider></mat-divider>
          <mat-option *ngFor="let data of SystemData" [value]="data.name" [title]="data.name"
            (click)="singleFilterItemSelectedHandler(SystemData,SystemSelected,allSystemSelected,'System')">
            {{data.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mat-form-group">
      <mat-form-field class="mat-form-input-field input-field-wide">
        <mat-label class="mat-form-group-label">Organization</mat-label>
        <mat-select [formControl]="OrgSelected" multiple [title]="getTitleString(OrgSelected.value)">
          <mat-select-trigger class="mat-form-trigger-label">
            {{getSelectedString(OrgSelected, 'Organization')}}
          </mat-select-trigger>
          <mat-option #allOrgSelected [value]="allOptionText"
            (click)="allSelectedHandler(OrgSelected,OrganizationData,allOrgSelected,'Organization')">{{allOptionText}}
          </mat-option>
          <mat-divider></mat-divider>
          <mat-option *ngFor="let data of OrganizationData" [value]="data.name" [title]="data.name"
            (click)="singleFilterItemSelectedHandler(OrganizationData,OrgSelected,allOrgSelected,'Organization')">
            {{data.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mat-form-group" style="width: 150px;">
      <mat-form-field class="mat-form-input-field input-field-medium">
        <mat-label class="mat-form-group-label">Year</mat-label>
        <mat-select [formControl]="YearSelected" multiple [title]="getTitleString(YearSelected.value)">
          <mat-select-trigger class="mat-form-trigger-label">
            {{YearSelected.value ? YearSelected.value[0] : ''}}
            <span *ngIf="YearSelected.value?.length > 1" class="example-additional-selection">
              <!-- (+{{YearSelected.value.length - 1}} {{YearSelected.value?.length === 2 ? 'other' : 'others'}}) -->
              {{getSelectedString(YearSelected)}}
            </span>
          </mat-select-trigger>
          <mat-option #allYearSelected [value]="allOptionText"
            (click)="allSelectedHandler(YearSelected,YearData,allYearSelected,'Year')">{{allOptionText}}</mat-option>
          <mat-divider></mat-divider>
          <mat-option *ngFor="let data of YearData" [value]="data.name"
            (click)="singleFilterItemSelectedHandler(YearData,YearSelected,allYearSelected,'Year')">{{data.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mat-form-group" style="width: 180px;">
      <mat-form-field class="mat-form-input-field input-field-medium">
        <mat-label class="mat-form-group-label">Cohort</mat-label>
        <mat-select [formControl]="CohortSelected" multiple [title]="getTitleString(CohortSelected.value)">
          <mat-select-trigger class="mat-form-trigger-label">
            {{CohortSelected.value ? CohortSelected.value[0] : ''}}
            <span *ngIf="CohortSelected.value?.length > 1" class="example-additional-selection">
              <!-- (+{{CohortSelected.value.length - 1}} {{CohortSelected.value?.length === 2 ? 'other' : 'others'}}) -->
              {{getSelectedString(CohortSelected)}}
            </span>
          </mat-select-trigger>
          <mat-option #allCohortSelected [value]="allOptionText"
            (click)="allSelectedHandler(CohortSelected,CohortData,allCohortSelected,'Cohort')">
            {{allOptionText}}</mat-option>
          <mat-divider></mat-divider>
          <mat-option *ngFor="let data of CohortData" [value]="data.name"
            (click)="singleFilterItemSelectedHandler(CohortData,CohortSelected,allCohortSelected,'Cohort')">
            {{data.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mat-form-group-button">
      <button mat-stroked-button color="primary" class="right-button"
        (click)="showAdvancedFilters = !showAdvancedFilters">
        More Filters
      </button>
    </div>
    <div class="mat-form-group-button">
      <button *ngIf="!isLanding" mat-stroked-button color="primary" class="right-button marLeft5" (click)="onSubmit()" [disabled]="CohortSelected.disabled">Go
      </button>
    </div>
  </div>
</div>

<div *ngIf="showAdvancedFilters">
  <div class="screen-overlay"></div>
  <div class="overlay-container">

    <div class="selected-list-title">
      <span>More Filters</span>
      <span>
        <mat-icon (click)="closePopup()">close</mat-icon>
      </span>
    </div>
    
    <div class="selected-list">
      <div class="comparegrouptype-wrapper">
        <label class="comparegrouptype-radio-group-label">Compare Group Type</label>
        <mat-radio-group aria-labelledby="comparegrouptype-radio-group-label" class="comparegrouptype-radio-group" 
        [(ngModel)]="compareGroupType"
        (change)="compareGroupTypeOnChange($event)">
          <mat-radio-button [value]="customCompareGroupLabelText" checked class="comparegrouptype-radio-button">{{customCompareGroupLabelText}}</mat-radio-button>&nbsp;&nbsp;
          <mat-radio-button [value]="selfCompareGroupLabelText" class="comparegrouptype-radio-button">{{selfCompareGroupLabelText}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="filterRow">
        <mat-form-field class="mat-form-input-field input-field-wide">
          <mat-label class="mat-form-group-label">Benchmark</mat-label>
          <mat-select [formControl]="CompareGroupSelected" (selectionChange)="compareGroupOnChange($event)">
            <mat-select-trigger class="mat-form-trigger-label">
              {{CompareGroupSelected.value ? CompareGroupSelected.value : ''}}
            </mat-select-trigger>
            <mat-option *ngFor="let data of CompareGroupData" [title]="data.name" [value]="data.name" style="font-size: 12px;color: #696969;">
              {{data.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <span class="subHeader">Dimensions</span>
      </div>
      <div class="filterRow">

        <div class="filterlist">
          <span class="filter-header">Age</span>
          <mat-selection-list #AgeControl [formControl]="AgeSelected">
            <!-- [style.overflow]="'auto'" [style.height.px]="'150'" -->
            <mat-list-option #allAgeSelected (click)="allDimSelectedHandler(AgeSelected,AgeData,allAgeSelected,'Age')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of AgeData" [value]="data.name" [title]="data.name" checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allAgeSelected,'Age')">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist">
          <span class="filter-header">Employment Status</span>
          <mat-selection-list #EmploymentStatusControl [formControl]="EmploymentStatusSelected">
            <mat-list-option #allEmploymentStatusSelected
              (click)="allDimSelectedHandler(EmploymentStatusSelected,EmploymentStatusData,allEmploymentStatusSelected,'EmploymentStatus')" [value]="allOptionText" [title]="allOptionText"
              checkboxPosition="before">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of EmploymentStatusData" [value]="data.name" [title]="data.name" checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allEmploymentStatusSelected,'EmploymentStatus')">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist">
          <span class="filter-header">Ethnicity</span>
          <mat-selection-list #EthnicityControl [formControl]="EthnicitySelected">
            <mat-list-option #allEthnicitySelected
              (click)="allDimSelectedHandler(EthnicitySelected,EthnicityData,allEthnicitySelected,'Ethnicity')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of EthnicityData" [value]="data.name" [title]="data.name" checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allEthnicitySelected,'Ethnicity')">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist">
          <span class="filter-header">Gender</span>
          <mat-selection-list #GenderControl [formControl]="GenderSelected">
            <mat-list-option #allGenderSelected
              (click)="allDimSelectedHandler(GenderSelected,GenderData,allGenderSelected,'Gender')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of GenderData" [value]="data.name" [title]="data.name" checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allGenderSelected,'Gender')">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
      </div>
      <div class="filterRow">

        <div class="filterlist">
          <span class="filter-header">GPA</span>
          <mat-selection-list #GPAControl [formControl]="GPASelected">
            <mat-list-option #allGPASelected (click)="allDimSelectedHandler(GPASelected,GPAData,allGPASelected,'GPA')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of GPAData" [value]="data.name" [title]="data.name" checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allGPASelected,'GPA')">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist">
          <span class="filter-header">Nursing Degree Received</span>
          <mat-selection-list #DegreeAwardedControl [formControl]="DegreeAwardedSelected">
            <!-- [(ngModel)]="selectedValue" -->
            <mat-list-option #allDegreeAwardedSelected
              (click)="allDimSelectedHandler(DegreeAwardedSelected,DegreeAwardedData,allDegreeAwardedSelected,'DegreeAwarded')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before">{{allOptionText}}</mat-list-option>
            <!-- (click)="toggleAllSelection(degOption,'DegreeAwarded') "  -->
            <mat-list-option *ngFor="let data of DegreeAwardedData" [value]="data.name" [title]="data.name" checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allDegreeAwardedSelected,'DegreeAwarded')">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist">
          <span class="filter-header">Previous Degree</span>
          <mat-selection-list #PreviousDegreeControl [formControl]="PreviousDegreeSelected">
            <mat-list-option #allPreviousDegreeSelected
              (click)="allDimSelectedHandler(PreviousDegreeSelected,PreviousDegreeData,allPreviousDegreeSelected,'PreviousDegree')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of PreviousDegreeData" [value]="data.name" [title]="data.name" checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allPreviousDegreeSelected,'PreviousDegree')">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist" *ngIf="isTerminationReport">
          <span class="filter-header">Termination Reason</span>
          <mat-selection-list #TerminationReasonControl [formControl]="TerminationReasonSelected">
            <mat-list-option #allTerminationReasonSelected
              (click)="allDimSelectedHandler(TerminationReasonSelected,TerminationReasonData,allTerminationReasonSelected,'TerminationReason')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of TerminationReasonData" [value]="data.name" [title]="data.name" checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allTerminationReasonSelected,'TerminationReason')">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist" *ngIf="is2006Reports==false">
          <span class="filter-header">Previous Health Care Experience</span>
          <mat-selection-list #PreviousHealthCareExperienceControl [formControl]="PreviousHealthCareExperienceSelected">
            <mat-list-option #allPreviousHealthCareExperienceSelected
              (click)="allDimSelectedHandler(PreviousHealthCareExperienceSelected,PreviousHealthCareExperienceData,allPreviousHealthCareExperienceSelected,'PreviousHealthCareExperience')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of PreviousHealthCareExperienceData" [value]="data.name" [title]="data.name" checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allPreviousHealthCareExperienceSelected,'PreviousHealthCareExperience')">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist">
          <span class="filter-header">Unit</span>
          <mat-selection-list #UnitControl [formControl]="UnitSelected">
            <mat-list-option #allUnitSelected
              (click)="allDimSelectedHandler(UnitSelected,UnitData,allUnitSelected,'Unit')" [value]="allOptionText" [title]="allOptionText"
              checkboxPosition="before">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of UnitData" [value]="data.name" [title]="data.name" checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allUnitSelected,'Unit')">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
      </div>

    </div>

    <!-- </ng-template> -->
    <div class="selected-list-footer">
      <button mat-stroked-button color="primary" class="selected-list-button" (click)="saveMoreFilters()">{{ isLanding? "Save Filters" : "Go" }}</button>
      <!-- <button mat-stroked-button color="primary" class="selected-list-button" (click)="saveMoreFilters()">Run</button> -->
      <!-- <button mat-stroked-button color="primary" (click)="showAdvancedFilters = !showAdvancedFilters"
        class="selected-list-button">Close</button> -->
      <button mat-stroked-button color="primary" class="selected-list-button" (click)="resetFilters()">Reset More
        Filters</button>
    </div>
  </div>
</div>
<div *ngIf="isApplyFiltersInProgress">
  <div class="screen-overlay"></div>
  <div class="overlay-container-loading">
    <div class="selected-list-title">
      <mat-progress-spinner color="accent" mode="indeterminate" value="50" diameter="40">
      </mat-progress-spinner>
      <span class="marLeft5">
        Loading, please wait..
      </span>
    </div>
  </div>
</div>
<div *ngIf="isLanding && !isApplyFiltersInProgress" style="clear: both;width: 99vw;">
  <div class="newRow" *ngIf="CompareGroupSelected.value != null">
    <span class="subText">Please follow these steps to customize the data displayed on the NRP data dashboard.</span>
    <span class="subText"><span class="step-style">Step 1.</span> Casey-Fink Experience Survey is the default report. To change the survey, please select from <span style="color: #ff4e00; font-weight: bold;">Surveys</span> menu bar.</span>
    <span class="report-title">{{this.pageTitle}}</span>
    <span class="subText"><span class="step-style">Step 2.</span> Choose the cohort year, cohort dates, and organization (if applicable)</span>
    <span class="subText"><span class="step-style">Step 3.</span> Select the benchmark</span>
    <div class="cardItem">
      <mat-card appearance="outlined" *ngIf="!isApplyFiltersInProgress" title="{{CompareGroupSelected.value}}">
        <mat-card-header>
          <mat-card-title  class="card-title">Compare Group</mat-card-title>
          <mat-card-subtitle>{{CompareGroupSelected.value}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <mat-icon (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
  
  <div class="newRow" *ngIf="!isApplyFiltersInProgress">
    <span class="subText"><span class="step-style">Step 4.</span> Select the demographic filters.</span>
    <span class="subTitle">Filters</span>
  </div>
  <div class="newRow" *ngIf="AgeSelected.value != null">
    <div class="cardItem" style="clear: both;">
      <mat-card appearance="outlined" *ngIf="!isApplyFiltersInProgress" title="{{getMatCardText(AgeSelected.value, 0)}}">
        <mat-card-header>
          <mat-card-title class="card-title">Age
            <!-- <mat-icon class="editIcon" (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon> -->
          </mat-card-title>
          <mat-card-subtitle>{{getMatCardText(AgeSelected.value)}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <mat-icon (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="cardItem">
      <mat-card appearance="outlined" *ngIf="!isApplyFiltersInProgress" title="{{getMatCardText(EmploymentStatusSelected.value, 0)}}">
        <mat-card-header>
          <mat-card-title class="card-title">Employment Status</mat-card-title>
          <mat-card-subtitle>{{EmploymentStatusSelected.value.includes("All") ? "All": EmploymentStatusSelected.value}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <mat-icon (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="cardItem">
      <mat-card appearance="outlined" *ngIf="!isApplyFiltersInProgress" title="{{getMatCardText(EthnicitySelected.value, 0)}}">
        <mat-card-header>
          <mat-card-title class="card-title">Ethnicity</mat-card-title>
          <mat-card-subtitle>
            <!-- {{EthnicitySelected.value.includes("All") ? "All": EthnicitySelected.value}} -->
            {{getMatCardText(EthnicitySelected.value)}}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <mat-icon (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="cardItem">
      <mat-card appearance="outlined" *ngIf="!isApplyFiltersInProgress" title="{{getMatCardText(GenderSelected.value, 0)}}">
        <mat-card-header>
          <mat-card-title class="card-title">Gender</mat-card-title>
          <mat-card-subtitle>
            <!-- {{GenderSelected.value.includes("All") ? "All": GenderSelected.value}} -->
            {{getMatCardText(GenderSelected.value)}}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <mat-icon (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon>
        </mat-card-actions>
      </mat-card>
    </div> 
    <div class="cardItem">
      <mat-card appearance="outlined" *ngIf="!isApplyFiltersInProgress" title="{{getMatCardText(GPASelected.value, 0)}}">
        <mat-card-header>
          <mat-card-title class="card-title">GPA</mat-card-title>
          <mat-card-subtitle>
            <!-- {{GPASelected.value.includes("All") ? "All": GPASelected.value}} -->
            {{getMatCardText(GPASelected.value)}}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <mat-icon (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
  <div class="newRow" *ngIf="GPASelected.value != null">
    
    <div class="cardItem">
      <mat-card appearance="outlined" *ngIf="!isApplyFiltersInProgress" title="{{getMatCardText(DegreeAwardedSelected.value, 0)}}">
        <mat-card-header>
          <mat-card-title class="card-title">Nursing Degree Received</mat-card-title>
          <mat-card-subtitle>
              <!-- {{DegreeAwardedSelected.value.includes("All") ? "All": DegreeAwardedSelected.value }} -->
              {{getMatCardText(DegreeAwardedSelected.value)}}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <mat-icon (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="cardItem">
      <mat-card appearance="outlined" *ngIf="!isApplyFiltersInProgress" title="{{getMatCardText(PreviousDegreeSelected.value, 0)}}">
        <mat-card-header>
          <mat-card-title class="card-title">Previous Degree</mat-card-title>
          <mat-card-subtitle>
            <!-- {{PreviousDegreeSelected.value.includes("All") ? "All": PreviousDegreeSelected.value}} -->
            {{getMatCardText(PreviousDegreeSelected.value)}}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <mat-icon (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="cardItem">
      <mat-card appearance="outlined" *ngIf="!isApplyFiltersInProgress"  title="{{getMatCardText(PreviousHealthCareExperienceSelected.value, 0)}}">
        <mat-card-header>
          <mat-card-title class="card-title">Previous Health Care Experience</mat-card-title>
          <mat-card-subtitle>
            <!-- {{UnitSelected.value.includes("All") ? "All": UnitSelected.value}} -->
             {{getMatCardText(PreviousHealthCareExperienceSelected.value)}}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <mat-icon (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="cardItem">
      <mat-card appearance="outlined" *ngIf="!isApplyFiltersInProgress"  title="{{getMatCardText(UnitSelected.value, 0)}}">
        <mat-card-header>
          <mat-card-title class="card-title">Unit</mat-card-title>
          <mat-card-subtitle>
            <!-- {{UnitSelected.value.includes("All") ? "All": UnitSelected.value}} -->
             {{getMatCardText(UnitSelected.value)}}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <mat-icon (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon>
        </mat-card-actions>
      </mat-card>
    </div>
    
    <div class="cardItem">
      <mat-card appearance="outlined" *ngIf="!isApplyFiltersInProgress && isTerminationReport" title="{{getMatCardText(TerminationReasonSelected.value, 0)}}">
        <mat-card-header>
          <mat-card-title class="card-title">Termination Reason</mat-card-title>
          <mat-card-subtitle>{{TerminationReasonSelected.value.includes("All") ? "All": TerminationReasonSelected.value}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <mat-icon (click)="showAdvancedFilters = !showAdvancedFilters">edit</mat-icon>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
  
  <div class="newRow" *ngIf="!isApplyFiltersInProgress && AgeSelected.value != null">
    <span class="subText"><span class="step-style">Step 5.</span> Click on the "<span style="color: #7f5eba; font-weight: bold;">Go</span>" button to populate the dashboard.</span>
    <div class="mat-form-group-button" *ngIf="!isApplyFiltersInProgress" style="margin-top: 0px;">
      <button mat-raised-button color="primary" class="right-button marLeft5" (click)="LoadReport()" style="width: 85px;" id>Go</button>
    </div>
  </div>
   
</div>
<div id="embedReport" class="report-frame-withfilters" *ngIf="!isLanding"></div>
